<template>
    <!-- RADIO DISPLAY AMOUNT -->
    <el-form-item
        :label="$t.__('dashboard.forms.FiscalYearsSelect.select_starting_tax_year')"
        prop="fiscal"
    >
        <el-select v-model="item" class="wp-2" @change="updateFiscalYears">
            <el-option
                v-for="fiscal in fiscalList"
                :key="fiscal.label"
                :label="fiscal.label"
                :value="fiscal.value"
                :disabled="fiscal.disabled"
            >
            </el-option>
        </el-select>
    </el-form-item>
</template>

<script>
export default {
    props: {
        fiscalYears: {
            type: Number,
            required: true,
        },
        limitFiscalyears: {
            type: Number,
            default: 3,
            required: false,
        },
    },
    data() {
        return {
            item: 0,
            fiscalList: [],
        };
    },
    created() {
        this.item = this.fiscalYears;
        this.$ajax.get('/rest/fiscalyears/getseveral/' + this.limitFiscalyears, {}, (data) => {
            if (data.length < this.item) {
                this.item = data.length;
            }
            for (let i = 1; i < 4; i++) {
                var y = i - 1;
                if (i === 1) {
                    var select = { label: 'N', value: i, disabled: false };
                } else if (typeof data[y] !== 'undefined') {
                    var select = { label: 'N-' + y, value: i, disabled: false };
                } else {
                    var select = { label: 'N-' + y, value: i, disabled: true };
                }
                this.fiscalList.push(select);
                this.$emit('loaded');
            }
        });
    },
    methods: {
        updateFiscalYears(data) {
            this.$emit('updateFiscalYears', data);
        },
    },
};
</script>
